// extracted by mini-css-extract-plugin
export default {"cls1":"Header-cls1_BWV","cls2":"Header-cls2__1q Header-cls1_BWV"};